import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const PATIENT_WAITING_LIST_SUB_NAV_ROUTES: IRoutesDefined = {
  PATIENT_WAITING_LIST: {
    id: "PATIENT_WAITING_LIST",
    title: "patient_waiting_list",
    icon: "PiUserListLight",
    path: "patient-waiting-list",
    RBACDisplayName: "PATIENT_WAITING_LIST_VIEW",
    RBACDescription: "Access to action button CTA in Patient Waiting List.",
    isVirtual: true,
    url: "/app/patient-waiting-list",
    children: {},
  },
  ACTION_BUTTON_PWL: {
    id: "ACTION_BUTTON_PWL",
    title: "patient_waiting_list",
    icon: "PiUserListLight",
    path: "patient-waiting-list",
    RBACDisplayName: "ACTION_BUTTON_CTA",
    RBACDescription: "Access to action button CTA in Patient Waiting List.",
    isVirtual: true,
    url: "/app/patient-waiting-list/cta-action",
    children: {},
  },

  // ── RBAC virtual features (pwl-scoped) ────────────────────────────
  PWL_SALES_TEAM_VIEW: {
    id: "PWL_SALES_TEAM_VIEW",
    title: "pwl sales team view",
    path: "cta",
    RBACDisplayName: "PWL_SALES_TEAM_VIEW",
    RBACDescription: "Patient Waiting List — sales team (BD) view: hides cart icon, filters differently.",
    url: "/app/patient-waiting-list/sales-view-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PWL_DOCTOR_VIEW: {
    id: "PWL_DOCTOR_VIEW",
    title: "pwl doctor view",
    path: "cta",
    RBACDisplayName: "PWL_DOCTOR_VIEW",
    RBACDescription: "Patient Waiting List — doctor-specific view (EMR access, hidden cart icon).",
    url: "/app/patient-waiting-list/doctor-view-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PWL_SUPER_ADMIN_VIEW: {
    id: "PWL_SUPER_ADMIN_VIEW",
    title: "pwl super admin view",
    path: "cta",
    RBACDisplayName: "PWL_SUPER_ADMIN_VIEW",
    RBACDescription: "Patient Waiting List — super admin view (EMR access without doctor role).",
    url: "/app/patient-waiting-list/super-admin-view-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  ALL_CLINICS_MULTI_SELECT: {
    id: "ALL_CLINICS_MULTI_SELECT",
    title: "all clinics multi select",
    path: "cta",
    RBACDisplayName: "ALL_CLINICS_MULTI_SELECT",
    RBACDescription: "Show the 'All Clinics' option in clinic multi-select filters (PWL, At-Home Services).",
    url: "/app/filters/all-clinics-multi-select-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};

export const AT_HOME_SERVICES_SUB_NAV_ROUTES: IRoutesDefined = {
  AT_HOME_SERVICES: {
    id: "AT_HOME_SERVICES",
    title: "at_home_services",
    icon: "PiUserListLight",
    path: "at-home-services",
    isVirtual: true,
    url: "/app/at-home-services",
    children: {},
  },
  ACTION_BUTTON_AT_HOME_SERVICES: {
    id: "ACTION_BUTTON_AT_HOME_SERVICES",
    title: "at_home_services",
    icon: "PiUserListLight",
    path: "at-home-services",
    RBACDisplayName: "HOME_SERVICES_ACTION_BUTTON_CTA",
    RBACDescription: "Access to action button CTA in At Home Services.",
    isVirtual: true,
    url: "/app/at-home-services/cta-action",
    children: {},
  },
};

export const STAFF_CALENDAR_SUB_NAV_ROUTES: IRoutesDefined = {
  STAFF_CALENDAR: {
    id: "STAFF_CALENDAR",
    title: "Staff_Calender",
    icon: "HiOutlineUserCircle",
    path: "staff-calendar",
    RBACDisplayName: "STAFF_CALENDAR_VIEW",
    RBACDescription: "Access to staff calendar view.",
    isVirtual: true,
    url: "/app/staff-calendar",
    children: {},
  },
};

